import { render, staticRenderFns } from "./SpecialScheme.vue?vue&type=template&id=45df40db&"
import script from "./SpecialScheme.vue?vue&type=script&lang=js&"
export * from "./SpecialScheme.vue?vue&type=script&lang=js&"
import style0 from "./SpecialScheme.vue?vue&type=style&index=0&id=45df40db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports